import {
  PermissionOperation,
  PermissionType,
  PermissionCode
} from '../helpers/permissionHelper';

export const appRoutes = {
  label: 'Eva3',
  children: [
    {
      name: 'Home',
      icon: 'home',
      children: [
        {
          name: 'Home',
          to: '/',
          exact: true,
          active: true
        },
        {
          name: 'Back to EVA',
          to: 'https://eva.emplas.co.uk/',
          exact: true,
          active: true
        }
      ],
      active: true
    },
    {
      name: 'Elvis',
      icon: 'comments',
      to: '/elvis',
      exact: true,
      active: true
    },
    {
      name: 'Dashboards',
      icon: 'chart-line',
      children: [
        {
          name: 'New & Critical Dashboard',
          to: '/new-critical/nc-dashboard',
          // icon: 'home',
          exact: true,
          active: true
        },
        {
          name: 'Stillage Dashboard',
          to: '/stillages/stillage-dashboard',
          exact: true,
          active: true
        },
        {
          name: 'Stillage Collections',
          to: '/stillages/stillage-collection',
          exact: true,
          active: true
        },
        {
          name: 'Glass Management Dashboard',
          to: 'glass-dashboard',
          exact: true,
          active: true
        },
        {
          permission_codes: [PermissionCode.Dashboard],
          permission_required_type: PermissionOperation.And,
          permissions: [PermissionType.View],
          name: 'Dashboard List',
          to: 'dashboard/list',
          exact: true,
          active: true
        },
        {
          permission_codes: [PermissionCode.LorryLoadingDashboard],
          permission_required_type: PermissionOperation.Or,
          permissions: [PermissionType.View],
          name: 'Lorry Loading',
          to: 'dashboard/lorry-loading-sumary/dashboard',
          exact: true,
          active: true
        },
        {
          permission_codes: [PermissionCode.Dashboard],
          permission_required_type: PermissionOperation.Or,
          permissions: [PermissionType.View],
          name: 'View Dashboard',
          to: 'dashboard/view',
          exact: true,
          active: false,
          hidden: true
        },
        {
          permission_codes: [PermissionCode.Dashboard],
          permission_required_type: PermissionOperation.Or,
          permissions: [
            PermissionType.Edit,
            PermissionType.Create,
            PermissionType.Update
          ],
          name: 'Edit Dashboard',
          to: 'dashboard/edit',
          exact: true,
          active: false,
          hidden: true
        },
        {
          permission_codes: [PermissionCode.DashboardQuery],
          permission_required_type: PermissionOperation.Or,
          permissions: [PermissionType.View],
          name: 'Query List',
          to: 'dashboard/queries',
          exact: true,
          active: true,
          hidden: true
        },
        {
          permission_codes: [PermissionCode.DashboardQuery],
          permission_required_type: PermissionOperation.Or,
          permissions: [PermissionType.View],
          name: 'Edit Query',
          to: 'dashboard/query',
          exact: true,
          active: false,
          hidden: true
        }
      ],
      active: true
    },
    {
      name: 'Service Desk',
      icon: 'comments',
      permission_codes: [PermissionCode.ServiceDesk],
      children: [
        {
          name: 'Kanban Board',
          to: 'service-desk/board',
          exact: true,
          active: true
        },
        {
          name: 'Activity',
          to: 'service-desk/activity',
          exact: true,
          active: true
        },
        {
          name: 'Queues',
          exact: true,
          active: true,
          children: [
            {
              name: 'All Open',
              to: 'service-desk/queue/allOpen',
              exact: true,
              active: true
            },
            {
              name: 'Unassigned',
              to: 'service-desk/queue/unassigned',
              exact: true,
              active: true
            },
            {
              name: 'Assigned To Me',
              to: 'service-desk/queue/assignedToMe',
              exact: true,
              active: true
            },
            {
              name: 'Reported By Me',
              to: 'service-desk/queue/reportedByMe',
              exact: true,
              active: true
            },
            {
              name: 'Recently Updated',
              to: 'service-desk/queue/recentlyUpdated',
              exact: true,
              active: true
            },
            {
              name: 'Recently Closed',
              to: 'service-desk/queue/recentlyClosed',
              exact: true,
              active: true
            }
          ]
        },
        {
          name: 'Admin',
          permission_codes: [PermissionCode.ServiceDeskAdmin],
          exact: true,
          active: true,
          children: [
            {
              name: 'Projects',
              to: 'service-desk/admin/projects',
              exact: true,
              active: true
            }
          ]
        }
      ],
      active: true
    },
    {
      name: 'Customer Support (CSO)',
      icon: 'headset',
      permission_codes: [PermissionCode.MMCustFocus],
      children: [
        {
          permission_codes: [PermissionCode.MMCustFocus],
          permission_required_type: PermissionOperation.Or,
          permissions: [
            PermissionType.View,
            PermissionType.Update,
            PermissionType.Create
          ],
          name: 'Customer Focus Dashboard',
          to: 'meeting-management/customer-focus-dashboard',
          exact: true,
          active: true
        }
      ],
      active: true
    },
    {
      permission_codes: [
        PermissionCode.SalespersonKPI,
        PermissionCode.SalespersonKPIManager
      ],
      name: 'Sales',
      active: true,
      icon: 'briefcase',
      children: [
        {
          permission_codes: [PermissionCode.SalespersonKPIManager],
          permission_required_type: PermissionOperation.Or,
          name: 'Management KPI’s',
          active: true,
          children: [
            {
              permission_codes: [PermissionCode.SalespersonKPIManager],
              permission_required_type: PermissionOperation.Or,
              permissions: [PermissionType.View],
              name: 'Sales Prospect',
              to: 'salesperson-kpi/sales-manager/prospect-customers',
              exact: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.SalespersonKPIManager],
              permission_required_type: PermissionOperation.Or,
              permissions: [PermissionType.View],
              name: 'Sales Visit',
              to: 'salesperson-kpi/sales-manager/sales-visits',
              exact: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.SalespersonKPIManager],
              permission_required_type: PermissionOperation.Or,
              permissions: [PermissionType.View],
              name: 'Sales Visit History',
              to: 'salesperson-kpi/sales-manager/sales-visits/history',
              exact: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.SalespersonKPIManager],
              permission_required_type: PermissionOperation.Or,
              permissions: [PermissionType.View],
              name: 'Sales KPI Target',
              to: 'salesperson-kpi/sales-manager/kpi-targets',
              exact: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.SalespersonKPIManager],
              permission_required_type: PermissionOperation.Or,
              permissions: [PermissionType.View],
              name: 'Sales KPI Summary',
              to: 'salesperson-kpi/sales-manager/kpi-summary',
              exact: true,
              active: true
            }
          ]
        },
        {
          permission_codes: [PermissionCode.SalespersonKPI],
          permission_required_type: PermissionOperation.Or,
          name: 'Personal Dashboard',
          active: true,
          children: [
            {
              permission_codes: [PermissionCode.SalespersonKPI],
              permission_required_type: PermissionOperation.Or,
              permissions: [
                PermissionType.View,
                PermissionType.Update,
                PermissionType.Create
              ],
              name: 'Add prospect',
              to: 'salesperson-kpi/personal-dashboard/prospect-customers',
              exact: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.SalespersonKPI],
              permission_required_type: PermissionOperation.Or,
              permissions: [
                PermissionType.View,
                PermissionType.Update,
                PermissionType.Create
              ],
              name: 'Log visits',
              to: 'salesperson-kpi/personal-dashboard/my-visits',
              exact: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.SalespersonKPI],
              permission_required_type: PermissionOperation.Or,
              permissions: [
                PermissionType.View,
                PermissionType.Update,
                PermissionType.Create
              ],
              name: 'Log visits History',
              to: 'salesperson-kpi/personal-dashboard/my-visits-history',
              visble: false,
              active: false
            },
            // {
            //   permission_codes: [PermissionCode.SalespersonKPI],
            //   permission_required_type: PermissionOperation.Or,
            //   permissions: [
            //     PermissionType.View,
            //     PermissionType.Update,
            //     PermissionType.Create
            //   ],
            //   name: 'Kpi Target',
            //   to: 'salesperson-kpi/personal-dashboard/kpi-target',
            //   exact: true,
            //   active: true
            // },
            {
              permission_codes: [PermissionCode.SalespersonKPI],
              permission_required_type: PermissionOperation.Or,
              permissions: [
                PermissionType.View,
                PermissionType.Update,
                PermissionType.Create
              ],
              name: 'Kpi Summary',
              to: 'salesperson-kpi/personal-dashboard/kpi-summary',
              exact: true,
              active: true
            }
          ]
        },
        {
          permission_codes: [PermissionCode.SalespersonKPI],
          permission_required_type: PermissionOperation.Or,
          permissions: [
            PermissionType.View,
            PermissionType.Update,
            PermissionType.Create
          ],
          name: 'New Business Analysis Dashboard',
          to: 'salesperson-kpi/new-business-analysis',
          exact: true,
          active: true
        }
      ]
    },
    {
      name: 'Purchasing',
      icon: 'shopping-cart',
      permission_codes: [
        PermissionCode.SlsLocations,
        PermissionCode.SlsAreas,
        PermissionCode.SLsStocks,
        PermissionCode.SlsBins,
        PermissionCode.SlsSites,
        PermissionCode.SupplierDashboard
      ],
      children: [
        {
          name: 'Stock Location System',
          active: true,
          permission_codes: [
            PermissionCode.SlsLocations,
            PermissionCode.SlsAreas,
            PermissionCode.SLsStocks,
            PermissionCode.SlsBins,
            PermissionCode.SlsSites
          ],
          children: [
            {
              name: 'Sites',
              active: true,
              permission_codes: [PermissionCode.SlsSites],
              icon: '',
              children: [
                {
                  name: 'Site Dashboard',
                  permission_codes: [PermissionCode.SlsSites],
                  permission_required_type: PermissionOperation.Or,
                  permissions: [
                    PermissionType.View,
                    PermissionType.Update,
                    PermissionType.Create
                  ],
                  to: 'stock-location/site-management/sites',
                  exact: true,
                  active: true
                },
                {
                  name: 'Site Manager',
                  permission_codes: [PermissionCode.SlsSites],
                  permission_required_type: PermissionOperation.Or,
                  permissions: [
                    PermissionType.View,
                    PermissionType.Update,
                    PermissionType.Create
                  ],
                  to: 'stock-location/site-management/site-manager',
                  exact: true,
                  active: true
                }
              ]
            },
            {
              name: 'Areas',
              permission_codes: [PermissionCode.SlsAreas],
              active: true,
              icon: '',
              children: [
                {
                  name: 'Area Dashboard',
                  permission_codes: [PermissionCode.SlsAreas],
                  permission_required_type: PermissionOperation.And,
                  permissions: [PermissionType.View],
                  to: 'stock-location/area-management/areas',
                  exact: true,
                  active: true
                },
                {
                  name: 'Area Manager',
                  permission_codes: [PermissionCode.SlsAreas],
                  permission_required_type: PermissionOperation.Or,
                  permissions: [
                    PermissionType.View,
                    PermissionType.Update,
                    PermissionType.Create
                  ],
                  to: 'stock-location/area-management/area-manager',
                  exact: true,
                  active: true
                }
              ]
            },
            {
              name: 'Locations',
              active: true,
              permission_codes: [PermissionCode.SlsLocations],
              icon: '',
              children: [
                {
                  name: 'Location Dashboard',
                  permission_codes: [PermissionCode.SlsLocations],
                  permission_required_type: PermissionOperation.And,
                  permissions: [PermissionType.View],
                  to: 'stock-location/location-management/locations',
                  exact: true,
                  active: true
                },
                {
                  permission_codes: [PermissionCode.SlsLocations],
                  permission_required_type: PermissionOperation.Or,
                  permissions: [
                    PermissionType.View,
                    PermissionType.Update,
                    PermissionType.Create
                  ],
                  name: 'Location Manager',
                  to: 'stock-location/location-management/location-manager',
                  exact: true,
                  active: true
                }
              ]
            },
            {
              name: 'Bins',
              active: true,
              permission_codes: [PermissionCode.SlsBins],
              icon: '',
              children: [
                {
                  name: 'Bin Dashboard',
                  permission_codes: [PermissionCode.SlsBins],
                  permission_required_type: PermissionOperation.And,
                  permissions: [PermissionType.View],
                  to: 'stock-location/bin-management/bins',
                  exact: true,
                  active: true
                },
                {
                  name: 'Bin Manager',
                  permission_codes: [PermissionCode.SlsBins],
                  permission_required_type: PermissionOperation.Or,
                  permissions: [
                    PermissionType.View,
                    PermissionType.Update,
                    PermissionType.Create
                  ],
                  to: 'stock-location/bin-management/bin-manager',
                  exact: true,
                  active: true
                }
              ]
            },
            {
              name: 'Stocks',
              active: true,
              permission_codes: [PermissionCode.SLsStocks],
              icon: '',
              children: [
                {
                  name: 'Stock Transactions',
                  permission_codes: [PermissionCode.SLsStocks],
                  permission_required_type: PermissionOperation.Or,
                  permissions: [PermissionType.View],
                  to: 'stock-location/stock-management/stock-transaction',
                  exact: true,
                  active: true
                },
                // {
                //   name: 'Stock Dashboard',
                //   to: 'stock-location/stock-management/stocks',
                //   exact: true,
                //   active: true
                // },
                {
                  name: 'Stock Search',
                  permission_codes: [PermissionCode.SLsStocks],
                  permission_required_type: PermissionOperation.Or,
                  permissions: [PermissionType.View],
                  to: 'stock-location/stock-management/stock-search',
                  exact: true,
                  active: true
                },
                {
                  name: 'Stock Movement',
                  permission_codes: [PermissionCode.SLsStocks],
                  permission_required_type: PermissionOperation.Or,
                  permissions: [PermissionType.View],
                  to: 'stock-location/stock-management/stock-movement',
                  exact: true,
                  active: true
                },
                {
                  name: 'Stock Check',
                  permission_codes: [PermissionCode.SLsStocks],
                  permission_required_type: PermissionOperation.Or,
                  permissions: [PermissionType.View],
                  to: 'stock-location/stock-management/stock-check',
                  exact: true,
                  active: true
                },
                {
                  permission_codes: [PermissionCode.SLsStocks],
                  permission_required_type: PermissionOperation.Or,
                  name: 'Delivery Discrepancy',
                  permissions: [PermissionType.View],
                  to: 'stock-location/stock-management/delivery-discrepancy',
                  exact: true,
                  active: true
                },
                {
                  permission_codes: [PermissionCode.SLsStocks],
                  permission_required_type: PermissionOperation.Or,
                  name: 'WPO Dashboard',
                  permissions: [PermissionType.View],
                  to: 'stock-location/stock-management/wpo-dashboard',
                  exact: true,
                  active: true
                },
                {
                  permission_codes: [PermissionCode.SLsStocks],
                  permission_required_type: PermissionOperation.Or,
                  name: 'Stock Request',
                  permissions: [PermissionType.View],
                  to: 'stock-location/stock-management/stock-request',
                  exact: true,
                  active: true
                }
              ]
            }
          ]
        },
        {
          name: 'Supplier management',
          active: true,
          permission_codes: [PermissionCode.SupplierDashboard],
          children: [
            {
              permission_codes: [PermissionCode.SupplierDashboard],
              permissions: [
                PermissionType.View,
                PermissionType.Update,
                PermissionType.Create
              ],
              name: 'Supplier Dashboard',
              to: 'supplier/supplier-dashboard',
              exact: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.SupplierDashboard],
              permissions: [
                PermissionType.View,
                PermissionType.Update,
                PermissionType.Create
              ],
              name: 'Supplier Details',
              icon: 'lock',
              to: 'supplier/supplier-details',
              exact: true,
              hidden: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.SupplierDashboard],
              permissions: [
                PermissionType.View,
                PermissionType.Update,
                PermissionType.Create
              ],
              name: 'Purchasing History',
              to: 'supplier/purchasing-history',
              exact: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.SupplierDashboard],
              permissions: [
                PermissionType.View,
                PermissionType.Update,
                PermissionType.Create
              ],
              name: 'Supplier OTIF',
              to: 'supplier/supplier-otif',
              exact: true,
              hidden: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.SupplierDashboard],
              permissions: [
                PermissionType.View,
                PermissionType.Update,
                PermissionType.Create
              ],
              name: 'Supplier Products',
              icon: 'lock',
              to: 'supplier/supplier-products',
              exact: true,
              hidden: true,
              active: true
            }
          ]
        }
      ],
      active: true
    },
    {
      permission_codes: [
        PermissionCode.Production,
        PermissionCode.ProductionOverview,
        PermissionCode.ProductionRTLMissing
      ],
      name: 'Production',
      icon: 'box-open',
      active: true,
      children: [
        {
          name: 'RTL Missing Scan Dashboard',
          to: 'production/rtl-missing-scanned',
          exact: true,
          active: true,
          permission_codes: [PermissionCode.ProductionRTLMissing],
          permission_required_type: PermissionOperation.Or,
          permissions: [
            PermissionType.View,
            PermissionType.Update,
            PermissionType.Create
          ]
        },
        {
          name: 'Production Overview Dashboard',
          to: 'production/production-overview-dashboard',
          excat: true,
          active: true,
          permission_codes: [PermissionCode.ProductionOverview],
          permission_required_type: PermissionOperation.Or,
          permissions: [
            PermissionType.View,
            PermissionType.Update,
            PermissionType.Create
          ]
        },
      ],
    },
    {
      name: 'HR',
      icon: 'user-friends',
      permission_codes: [
        PermissionCode.SmArea,
        PermissionCode.SmSection,
        PermissionCode.SmSkillActivity,
        PermissionCode.SmSkillCriteria,
        PermissionCode.SmSkillLevel,
        PermissionCode.SmSkillMaxtrix,
        PermissionCode.SmSubSkill,
        PermissionCode.SmSubSkillTraining,
        PermissionCode.SmTrainingRecord,
        PermissionCode.EVUserDashboard,
        PermissionCode.EVAdminDashboard,
        PermissionCode.EmployeeRecognition,
        PermissionCode.EmployeeRecognitionReports
      ],
      children: [
        {
          name: 'Skill Matrix',
          permission_codes: [
            PermissionCode.SmSkillMaxtrix,
            PermissionCode.SmSkillCriteria,
            PermissionCode.SmSkillLevel,
            PermissionCode.SmSkillActivity,
            PermissionCode.SmSubSkill
          ],
          exact: true,
          active: true,
          children: [
            {
              permission_codes: [PermissionCode.SmSkillMaxtrix],
              permission_required_type: PermissionOperation.And,
              permissions: [PermissionType.View],
              name: 'Skill Matrix Management',
              exact: true,
              active: true,
              to: 'hr/skill-matrix'
            },

            {
              permission_codes: [
                PermissionCode.SmSkillCriteria,
                PermissionCode.SmSkillLevel,
                PermissionCode.SmSkillActivity,
                PermissionCode.SmSubSkill
              ],
              name: 'Skill Management',
              exact: true,
              active: true,
              children: [
                {
                  permission_codes: [PermissionCode.SmSkillCriteria],
                  permission_required_type: PermissionOperation.And,
                  permissions: [PermissionType.View],
                  name: 'Skill Criteria',
                  to: 'hr/skill-matrix/skills/criteria-dashboard',
                  exact: true,
                  active: true
                },
                {
                  permission_codes: [PermissionCode.SmSkillLevel],
                  permission_required_type: PermissionOperation.And,
                  permissions: [PermissionType.View],
                  name: 'Skill Level',
                  to: 'hr/skill-matrix/skills/skill-level-dashboard',
                  exact: true,
                  active: true
                },
                {
                  permission_codes: [PermissionCode.SmSkillActivity],
                  permission_required_type: PermissionOperation.And,
                  permissions: [PermissionType.View],
                  name: 'Skill Activity',
                  to: 'hr/skill-matrix/skills/skill-activity-dashboard',
                  exact: true,
                  active: true
                },
                {
                  permission_codes: [PermissionCode.SmSubSkill],
                  permission_required_type: PermissionOperation.And,
                  permissions: [PermissionType.View],
                  name: 'Sub Skill',
                  to: 'hr/skill-matrix/skills/sub-skill-dashboard',
                  exact: true,
                  active: true
                }
              ]
            }
          ]
        },
        {
          name: 'Training',
          permission_codes: [PermissionCode.SmTrainingRecord],
          exact: true,
          active: true,
          children: [
            {
              permission_codes: [PermissionCode.SmTrainingRecord],
              permission_required_type: PermissionOperation.And,
              permissions: [PermissionType.View],
              name: 'Training Record Manager',
              to: 'hr/skill-matrix/section/skills/core-training-record',
              exact: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.SmTrainingRecord],
              permission_required_type: PermissionOperation.And,
              permissions: [PermissionType.View],
              name: 'Training Dashboard',
              to: 'hr/skill-matrix/section/skills/core-training-dashboard',
              exact: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.SmTrainingRecord],
              permission_required_type: PermissionOperation.And,
              permissions: [PermissionType.View],
              name: 'Trainee Documents',
              to: 'hr/skill-matrix/training-managements/trainee-documents',
              exact: true,
              active: true
            }
          ]
        },

        {
          name: 'Sections & Areas Management',
          permission_codes: [PermissionCode.SmSection, PermissionCode.SmArea],
          exact: true,
          active: true,
          children: [
            {
              permission_codes: [PermissionCode.SmSection],
              permission_required_type: PermissionOperation.And,
              permissions: [PermissionType.View],
              name: 'Section Dashboard',
              to: 'hr/skill-matrix/section/section-dashboard',
              exact: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.SmArea],
              permission_required_type: PermissionOperation.And,
              permissions: [PermissionType.View],
              name: 'Area Dashboard',
              to: 'hr/skill-matrix/area/area-dashboard',
              exact: true,
              active: true
            }
          ]
        },
        {
          name: 'EV Charging Space Booking System',
          permission_codes: [
            PermissionCode.EVUserDashboard,
            PermissionCode.EVAdminDashboard
          ],
          exact: true,
          active: true,
          children: [
            {
              permission_codes: [PermissionCode.EVUserDashboard],
              permission_required_type: PermissionOperation.And,
              permissions: [PermissionType.View],
              name: 'Request',
              to: 'hr/charging-space-booking',
              exact: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.EVAdminDashboard],
              permission_required_type: PermissionOperation.And,
              permissions: [PermissionType.View],
              name: 'Admin',
              to: 'hr/charging-space-admin',
              exact: true,
              active: true
            }
          ]
        },
        {
          name: 'Employee Recognition',
          permission_codes: [
            PermissionCode.EmployeeRecognition,
            PermissionCode.EmployeeRecognitionReports
          ],
          exact: true,
          active: true,
          children: [
            {
              permission_codes: [PermissionCode.EmployeeRecognition],
              permission_required_type: PermissionOperation.And,
              permissions: [PermissionType.View],
              name: 'Recognise a Colleague',
              to: 'hr/recognition/nominate',
              exact: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.EmployeeRecognitionReports],
              permission_required_type: PermissionOperation.And,
              permissions: [PermissionType.View],
              name: 'Recognition Reports',
              to: 'hr/recognition/reports',
              exact: true,
              active: true
            }
          ]
        },
        {
          name: 'Setting',
          permission_codes: [PermissionCode.SmTrainingRecord],
          exact: true,
          active: true,
          children: [
            {
              permission_codes: [PermissionCode.SmTrainingRecord],
              permission_required_type: PermissionOperation.And,
              permissions: [PermissionType.View],
              name: 'Setting',
              to: 'hr/skill-matrix/setting',
              exact: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.SmTrainingRecord],
              permission_required_type: PermissionOperation.And,
              permissions: [PermissionType.View],
              name: 'Skill Level Config',
              to: 'hr/skill-matrix/area/area-skill-level-config',
              exact: true,
              active: true
            }
          ]
        }
      ],
      active: true
    },
    {
      name: 'Management',
      icon: 'tasks',
      permission_codes: [
        PermissionCode.MMMeetingDashboard,
        PermissionCode.MMCustFocus
      ],
      children: [
        {
          permission_codes: [
            PermissionCode.MMMeetingDashboard,
            PermissionCode.MMCustFocus
          ],
          name: 'Meeting Management',
          active: true,
          // icon: 'tasks', //'user-plus',
          children: [
            {
              permission_codes: [PermissionCode.MMMeetingDashboard],
              permission_required_type: PermissionOperation.Or,
              permissions: [
                PermissionType.View,
                PermissionType.Update,
                PermissionType.Create
              ],
              name: 'Meeting Dashboard',
              to: 'meeting-management/meeting-dashboard',
              exact: true,
              active: true
            },
            {
              permission_codes: [PermissionCode.MMCustFocus],
              permission_required_type: PermissionOperation.Or,
              permissions: [
                PermissionType.View,
                PermissionType.Update,
                PermissionType.Create
              ],
              name: 'Customer Focus Dashboard',
              to: 'meeting-management/customer-focus-dashboard',
              exact: true,
              active: true
            },
            {
              name: 'Meeting Diary',
              to: '/customer-service/meetings/calendar',
              exact: true,
              active: true
            }
          ]
        },
        {
          name: 'Action Plans Board',
          to: '/customer-service/action-plan-board',
          exact: true,
          active: true
        }
      ],
      active: true
    },
    {
      name: 'Reports',
      icon: 'file-alt',
      permission_codes: [PermissionCode.BsSectorMeasurable],
      children: [
        {
          permission_codes: [
            PermissionCode.BsSectorMeasurable,
            PermissionCode.BsSectorMeasurableData,
            PermissionCode.BsSectorMeasurableTarget
          ],
          name: 'KPI Balanced Scorecard',
          to: 'kpi-balanced-scorecard',
          permissions: [
            PermissionType.View,
            PermissionType.Update,
            PermissionType.Create
          ],
          exact: true,
          active: true
        }
      ],
      active: true
    },
    {
      permission_codes: [PermissionCode.JiraProjectManagement],
      name: 'IT & Systems',
      active: true,
      icon: 'desktop',
      children: [
        {
          permission_codes: [PermissionCode.JiraProjectManagement],
          permission_required_type: PermissionOperation.Or,
          permissions: [
            PermissionType.View,
            PermissionType.Update,
            PermissionType.Create
          ],
          name: 'Jira Project Management',
          to: 'it/jira-project-management',
          exact: true,
          active: true
        }
      ]
    },
    {
      name: 'Admin',
      active: true,

      permission_codes: [PermissionCode.PMSetup, PermissionCode.PMUserPm],
      icon: 'lock',
      children: [
        {
          permission_codes: [PermissionCode.PMSetup, PermissionCode.PMUserPm],
          name: 'Permissions Management',
          active: true,
          icon: 'lock',
          children: [
            {
              name: 'Permission Setup Management',
              permission_codes: [PermissionCode.PMSetup],
              permission_required_type: PermissionOperation.Or,
              permissions: [
                PermissionType.View,
                PermissionType.Update,
                PermissionType.Create
              ],
              active: true,
              icon: 'lock',
              children: [
                {
                  permission_codes: [PermissionCode.PMSetup],
                  permission_required_type: PermissionOperation.Or,
                  permissions: [
                    PermissionType.View,
                    PermissionType.Update,
                    PermissionType.Create
                  ],
                  name: 'Permission Setup Dashboard',
                  to: 'admin/permission/permissions-setup/permission-setup-dashboard',
                  exact: true,
                  active: true
                }
              ]
            },
            {
              permission_codes: [PermissionCode.PMUserPm],
              permission_required_type: PermissionOperation.Or,
              permissions: [
                PermissionType.View,
                PermissionType.Update,
                PermissionType.Create
              ],
              name: 'User Permission Management',
              active: true,
              icon: 'user',
              children: [
                {
                  permission_codes: [PermissionCode.PMUserPm],
                  permission_required_type: PermissionOperation.Or,
                  permissions: [
                    PermissionType.View,
                    PermissionType.Update,
                    PermissionType.Create
                  ],
                  name: 'User Permission Dashboard',
                  to: 'admin/permission/user-permission/user-permission-dashboard',
                  exact: true,
                  active: true
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

export const hiddenRoutes = {
  hidden: true,
  label: 'Hidden Routes',
  children: [
    {
      name: 'KPI Detail Page',
      permission_codes: [
        PermissionCode.BsSectorMeasurable,
        PermissionCode.BsSectorMeasurableData,
        PermissionCode.BsSectorMeasurableTarget
      ],
      children: [
        {
          permission_codes: [
            PermissionCode.BsSectorMeasurable,
            PermissionCode.BsSectorMeasurableData,
            PermissionCode.BsSectorMeasurableTarget
          ],
          name: 'KPI Balanced Scorecard',
          to: 'kpi-balanced-scorecard/:id',
          permissions: [
            PermissionType.View,
            PermissionType.Update,
            PermissionType.Create
          ],
          exact: true,
          active: true
        }
      ]
    }
  ]
};

export default [appRoutes, hiddenRoutes];
